import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';
import {wrapNotFound} from '../../app/NotFoundHandler.react';
import ChannelIcon from '../../channel-defs/ChannelIcon.react';

class companySearchViewChannelEl extends React.Component {
	static propTypes = {
		user: PropTypes.object.isRequired,
	};

	render() {
		return (
			<div>
				<ChannelIcon channelDef={this.props.user.channelDef} size={32}/> <i>{this.props.user.channelDef.name}</i>
			</div>
		);
	}
}

// TODO clear the request fields from unnecessary items
export default Relay.createContainer(wrapNotFound(companySearchViewChannelEl, (props) => {
	return props.user.channelDef;
}), {
	initialVariables: {
		channelDefId: '',
	},
	prepareVariables (variables) {
		return variables;
	},
	fragments: {
		user: () => {
			return Relay.QL`
				fragment on User {
					channelDef(id: $channelDefId) {
						id,
						realId,
						name,
						description,
						icon,
						virtual,
						metadata,
						urlFragment,
					}
				}
			`;
		}
	}
});
